if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios');
      this.bundleSelects = this.querySelector('.bundle-products-inputs');
      this.submitButton = this.querySelector('[type="submit"]');
      this.selectButton = this.querySelector('[name="select"]');
      this.modalButton = this.querySelector('[name="modal"]');
      this.modalCloseButton = this.querySelector('.product__info--overlay') || this.querySelector('.product__bundle .product__title .icon-close');
      this.modalContainer = this.querySelector(".product__info-container--fixed");
      this.buttonsContainer = this.querySelector(".product-form__buttons");
      this.productLookButton = this.querySelector(".link--add-ons");

      if(this.modalButton) this.modalButton.addEventListener("click", this.onModalOpen.bind(this));
      if(this.modalCloseButton) this.modalCloseButton.addEventListener('click', this.onModalClose.bind(this));

      if (this.variantSelects) {
        this.variantSelects.addEventListener('change', this.onVariantChange.bind(this));
        this.setUnselectedVariant();
      }

      if (this.bundleSelects) {
        this.bundleSelects.addEventListener('change', this.onBundleChange.bind(this));
      }

      if (this.productLookButton && this.modalContainer) {
        this.productLookButton.addEventListener('click', this.completeYourLook.bind(this))
      }
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setUnselectedVariant() {
      if (document.querySelector(".product-form__input:not(.single-variant) input:checked")) {
        document.querySelector(".product-form__input:not(.single-variant) input:checked").checked = false;
        this.buttonsContainer.classList.add("select");
      }
      if (this.selectButton) {
        this.selectButton.addEventListener("click", () => {
          document.querySelector(".product-form__error-message-wrapper").removeAttribute("hidden");
        })
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    onVariantChange() {
      if (this.selectButton) {
        this.buttonsContainer.classList.remove("select");
        this.selectButton.classList.add("hidden");
        this.submitButton.classList.remove("hidden");
      }
      if (this.variantSelects) {
        if (this.variantSelects.querySelector(".product-form__input--color")) {
          let currentColor = this.variantSelects.querySelector("input:checked").value;
          document.querySelector(".form__label-color-option").textContent = currentColor;
        }
      }
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }

    onModalOpen(evt) {
      evt.preventDefault();
      this.modalContainer.classList.add("open");
    }

    onModalClose(evt) {
      evt.preventDefault();
      this.modalContainer.classList.remove("open");
    }

    completeYourLook(e) {
      e.preventDefault();
      this.modalContainer.classList.remove("open"); 
      const targetId = this.productLookButton.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      const scrollToPosition = targetElement.offsetTop;

      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
  }
)};
